import { config } from "../../../../enviroment";
import { apolloClientService } from "../../../../services/apollo-client";
export const autoPayServices = {
    getAutoPayRecords,
    deleteAutoPayRecord,
    updateAutoPayRecords,
    createAndSaveNewRecord,
    getSourceList,
    getDropdownpData
}
function getAutoPayRecords(accountId) {
    let APIquery =
        `query{ 
        getAutoPayData
    }
    `
    let Headers = { accountId: accountId }
    return apolloClientService.ApolloClientgqlsUsage(APIquery, Headers, "network-only");
}
function getSourceList(accountId) {
    let APIquery =
        `query{
            getSourceCdList 
        }
        `
    let Headers = { accountId: accountId }
    return apolloClientService.ApolloClientgqlsUsage(APIquery, Headers);
}
function deleteAutoPayRecord(accountId, autoPayId) {
    let deleteAPIQuery = `query{deleteAutoPay(input:{
        accountId: "`+ accountId + `", 
        autoPayId: "`+ autoPayId + `",
        tenantCode: "`+ config.constants.BASE_TENANT_CODE + `"
    })}`

    let Headers = { accountId: accountId }
    return apolloClientService.ApolloClientgqlsUsage(deleteAPIQuery, Headers);
}

function updateAutoPayRecords(accountId, modifiedRecord) {
    let Headers = { accountId: accountId }
    let date = modifiedRecord.expireDate;
    let month;
    let year;
    let modifiedFinalRecord = {};
    let withDrawal_amount = modifiedRecord.autopayMaxWithdrawalAmount;
    if (date && date.includes("/") && date.split("/").length > 1) {
        year = date.split("/")[1]
        month = date.split("/")[0]
    }
    else if (date && date.includes("-") && date.split("-").length > 2) {
        month = date.split("-")[1]
        year = date.split("-")[0]
    }
    else if (date === "" && month === undefined && year === undefined) {
        month = "";
        year = "";
    }
    if (withDrawal_amount === "") {
        withDrawal_amount = 0;
    }
    if(modifiedRecord?.autoPayMethod === "Bank"){
        month = "";
        year = ""
    }
    if(modifiedRecord?.endDate === null){
        modifiedFinalRecord = {...modifiedRecord, ['endDate']: ''}
    }
    else{
        modifiedFinalRecord = modifiedRecord
    }
    let updateAPIQuery = `query{updateAutoPay(input:{
        startDate: "`+ modifiedRecord.startDate + `",
        endDate: "`+ modifiedFinalRecord.endDate + `",    
        autoPaySourceCode: "`+ modifiedRecord.autopaySource + `",    
        extAcctId: "`+ modifiedRecord.externalAccountId + `",    
        expiresOnMonth: "`+ month + `",  
        expiresOnYear: "`+ year + `",  
        name: "`+ modifiedRecord.entityName + `",    
        maxWithdrawlAmt: "`+ withDrawal_amount + `",    
        autoPayId: "`+ modifiedRecord.accountAutopayId + `",    
        mode: "`+ modifiedRecord.autoPayMethod + `",
        comments: "`+ modifiedRecord.comments + `"
    
    })}`
    return apolloClientService.ApolloClientgqlsUsage(updateAPIQuery, Headers, "network-only");
}

function createAndSaveNewRecord(accountId, newRecord) {
    let Headers = { accountId: accountId }
    let month;
    let year;
    if (newRecord.expireDate && newRecord.expireDate.includes("/")) {
        month = newRecord.expireDate.split("/")[0]
        year = newRecord.expireDate.split("/")[1]
    }
    else if (newRecord.expireDate === "" && month === undefined && year === undefined) {
        month = "";
        year = "";
    }

    if (newRecord.endDate === undefined) {
        newRecord.endDate = ""
    }
    if(newRecord?.autoPayMethod === "Bank"){
        month = "";
        year = ""
    }
    let modifiedFinalNewRecord = {}
    if(newRecord?.endDate === null){
        modifiedFinalNewRecord = {...newRecord, ['endDate']: ''}
    }
    else{
        modifiedFinalNewRecord = newRecord
    }
    let createAPIQuery = `query{createAutoPay(input:{startDate: "` + newRecord.startDate + `",
    endDate: "`+ modifiedFinalNewRecord.endDate + `",
    autoPaySourceCode: "`+ newRecord.autopaySource + `",
    extAcctId: "`+ newRecord.externalAccountId + `",
    expiresOnMonth: "`+ month + `",             
    expiresOnYear:"`+ year + `"
    name: "`+ newRecord.entityName + `",
    maxWithdrawlAmt: "`+ newRecord.autopayMaxWithdrawalAmount + `",
    mode: "`+ newRecord.autoPayMethod + `",
    comments: "`+ newRecord.comments + `"
})}`
    return apolloClientService.ApolloClientgqlsUsage(createAPIQuery, Headers, "network-only");
}

function getDropdownpData(groupCode,languageCode) {
    let APIquery =
      `{  getDropdownData(input:{groupCode:"` +
      groupCode +
      `",languageCode:"`+languageCode+`"})
     }`;
    return apolloClientService.ApolloClientgqls(APIquery);
  }